import { loginRequest } from '@/config/authConfig';
import Env from '@/config/env';
import msalInstance from '@/lib/msalInstance';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import axios from 'axios';

const api = axios.create({
  baseURL: Env.API_URL,
  withCredentials: true
});

api.interceptors.request.use(
  async (config) => {
    if (Env.IS_PROD) {
      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
          const token = response.idToken;
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Token acquisition failed:', error);
        if (error instanceof InteractionRequiredAuthError) {
          await msalInstance.loginRedirect();
        } else {
          await msalInstance.logoutRedirect();
        }

        return Promise.reject(error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && Env.IS_PROD) {
      console.log('401 error, logging out user');
      msalInstance.logoutRedirect();
    }
    return Promise.reject(error);
  },
);

export default api;
